<template>
	<div>
		<vx-card title="Verzendadres" class="text-md" noShadow cardBorder>
			<template slot="actions">
				<print-shipping-label :order="this.order" :dymo-printer="dymoPrinter" />
			</template>
			{{ order.shipping.company }}<br>
			{{ order.shipping.full_name }}<br>
			{{ order.shipping.full_address }}<br>
			{{ order.shipping.zip_code }} {{ order.shipping.city }}<br>
			<p v-if="order.shipping.country_code === 'NL'">
				Nederland<br>
			</p>
			<p v-if="order.shipping.country_code === 'BE'">
				België<br>
			</p>
			<a :href="`mailto:${order.shipping.email}?subject=${order.order.type_email_subject}&body=Beste ${order.shipping.full_name},`">Email klant</a><br>
		</vx-card>
	</div>
</template>

<script>

import dymoPrinter from '@/services/dymo/dymoPrinter';
import PrintShippingLabel from '@/views/orderDetails/printShippingLabel';

export default {
	components: {
		PrintShippingLabel
	},
	props: {
		order: Object,
		dymoPrinter: {
			type: dymoPrinter,
			required: true
		}
	},
}
</script>
